import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingScreen } from './LoadingScreen';

export const ProtectedRoute = ({ children, roles }) => {
  const { account, loading } = useAuth();

  if (loading) {
    return (
      <LoadingScreen label="Loading…" />
    );
  }

  if (!account) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(account.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
